import { ReactComponent as TaskIconSVG } from '@/assets/icons/New-Tasks-paths.svg';
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export const TaskIcon = ({ bgColor = '#E5DAFF', width='24px', height='24px', ...props }) => {
	const { color } = props;
    
	return (
		<SvgIcon
			{...props}
			sx={{
				backgroundColor: bgColor, 
				width: width,
				height: height,
				borderRadius: 2,
				'& path': { fill: color },
				'& path[stroke]': { fill: 'none', stroke: color },
			}}
		>
			<TaskIconSVG />
		</SvgIcon>
	);
};
